import LegalLayout, { Section } from "@/components/landing/LegalLayout";

export default function Impressum() {
  return (
    <LegalLayout label="Rechtliches" title="Impressum" testid="impressum-page">
      <Section index="01" title="Angaben gemäß § 5 DDG" testid="impressum-section-betreiber">
        <p>
          DROPS Dienstleistung Schäfer
          <br />
          Daniel Schäfer
          <br />
          Viktor-Reuter-Straße 7
          <br />
          44623 Herne, Deutschland
        </p>
        <p className="text-white/60">Marke: DROPS TFR — Technical First Responder</p>
      </Section>

      <Section index="02" title="Kontakt" testid="impressum-section-kontakt">
        <p>
          Telefon:{" "}
          <a data-testid="impressum-phone-link" href="tel:+49177857960" className="text-white transition-colors duration-300 hover:text-[#F5B301]">
            0177 857960
          </a>
          <br />
          E-Mail:{" "}
          <a data-testid="impressum-email-link" href="mailto:drops33@web.de" className="text-white transition-colors duration-300 hover:text-[#F5B301]">
            drops33@web.de
          </a>
        </p>
      </Section>

      <Section index="03" title="Verantwortlich für den Inhalt" testid="impressum-section-verantwortlich">
        <p>
          Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:
          <br />
          Daniel Schäfer, Anschrift wie oben
        </p>
      </Section>

      <Section index="04" title="EU-Streitschlichtung" testid="impressum-section-streitschlichtung">
        <p>
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung (OS) bereit:{" "}
          <a
            data-testid="impressum-os-link"
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white transition-colors duration-300 hover:text-[#F5B301]"
          >
            https://ec.europa.eu/consumers/odr
          </a>
          . Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>
      </Section>

      <Section index="05" title="Verbraucherstreitbeilegung" testid="impressum-section-verbraucher">
        <p>
          Wir sind nicht bereit oder verpflichtet, an
          Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
          teilzunehmen.
        </p>
      </Section>

      <Section index="06" title="Haftung für Inhalte" testid="impressum-section-inhalte">
        <p>
          Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten
          nach den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine
          rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung
          oder Sperrung der Nutzung von Informationen nach den allgemeinen
          Gesetzen bleiben hiervon unberührt.
        </p>
      </Section>

      <Section index="07" title="Haftung für Links" testid="impressum-section-links">
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten
          Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
          verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
          Verlinkung auf mögliche Rechtsverstöße überprüft.
        </p>
      </Section>

      <Section index="08" title="Urheberrecht" testid="impressum-section-urheberrecht">
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte, Luftaufnahmen und
          Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die
          Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
          Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
          schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
        </p>
      </Section>
    </LegalLayout>
  );
}
